import styled from "styled-components";
import {
  IMG_NOTICE,
  AuthBg,
  AuthLogo,
  IMG_APK,
  IMG_APPLE,
  IMG_PLAYSTORE,
} from "@assets";
import { Button as AntButton } from "antd";

export const ApkFilled = styled.img.attrs({
  alt: 'img',
  src: IMG_APK,
})`
width: 100%;
height: auto;
`;

export const AppleFilled = styled.img.attrs({
  alt: 'img',
  src: IMG_APPLE,
})`
width: 100%;
height: auto;
`;

export const PlayStoreFilled = styled.img.attrs({
  alt: 'img',
  src: IMG_PLAYSTORE,
})`
width: 100%;
height: auto;
`;

export const RootContainer = styled.div`
min-height: 100vh;
	padding: 16px;
  text-align: center;

  background: ${props => props.theme.primaryColor};
  background-image: url(${AuthBg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const RecaptchaContainer = styled.div`
  display: flex;
  justify-content: center !important;
  align-items: center;
  width: calc(100vw - 32px);
  height: calc(100vh - 60px);

  &>div{
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
`

export const Logo = styled(AuthLogo)`
  margin: 0 auto 0 auto;
  width: 100%;
  height: auto;
`

export const CloseContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  z-index: 1;

  svg {
    cursor: pointer;
  }
`;

export const Name = styled.span`
`;

export const Welcome = styled.div`
padding-bottom: 16px;
  color: #FFF;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px; /* 141.667% */

  display: flex;
  align-items: center;
  justify-content: center;

  span {
    padding: 4px 4px 0px 4px;
  }
`;

export const Container = styled.div`
padding-top: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const DescriptionContainer = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media screen and (max-width: 375px) {
    width: 90%;
  }
`;

export const Description = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  width: 75%;

  span {
    color: #FB0;
  }

  @media screen and (max-width: 375px) {
    width: 90%;
  }
`;

export const Button = styled(AntButton)`
  width: 100% !important;
  height: 48px !important;
  margin: 20px 0 0 0;
  box-shadow: none !important;
`;

export const FollowTitle = styled.div`
margin: 0;
  color:  #FB0;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 162.5% */
`;

export const DownloadWrapper = styled.div`
	gap: 15px !important;
  width: 100%;
  padding: 0;
  margin: 16px 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  a {
    width: 100%;
    display: flex;
  } 
  
  svg{
    width: 100%;
    height: auto;
  }
`;

export const FollowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  #app {
    width: 100%;
    height: 48px;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

export const ErrorImage = styled.img.attrs({
  alt: "img",
  src: IMG_NOTICE,
})`
  width: 80px;
  object-fit: contain;
  margin-top: 24px;
`;

export const ErrorTitle = styled.div`
  color: #e8e03c;
  font-weight: 800;
  font-size: 18px;
  margin-top: 16px;
`;

export const ErrorDescription = styled.div`
  color: #fff;
  width: 191px;
  font-size: 13px;
  font-weight: 400;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 23px;
  line-height: 30px;
`;

export const UserName = styled.div`
  color: var(--Text-Inverted, #FFF);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 171.429% */

  margin-top: 12px;
`;

export const TypeInfo = styled.div`
  color: #FB0;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 183.333% */
`;

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh);
	display: flex;
	align-items: center;
	justify-content: center;

  .ant-spin-dot i {
    background-color: #fff !important;
  }
`;

export const SocialWrapper = styled.div`
  width: calc(100% - 32px);
  gap: 8px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.30);
  backdrop-filter: blur(25px);

  margin-top: 16px;
  margin-bottom: 20px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;

  svg{
    width: 40px;
    height: 40px;
  }
`